<template>
	<div class="role">
		<el-tabs v-model="activeName" @tab-click="handleClick">
		    <el-tab-pane label="角色管理" name="first">
				<vs-row class="mb-4">
					<vs-col vs-type="flex">
						<el-button type="primary" plain icon="el-icon-plus" size="mini" @click="addrole">新增</el-button>
					</vs-col>
				</vs-row>
				<template>
				    <el-table
					  :header-cell-style="{background:'#F3F4F7',color:'#000000'}"
					  align="center"
				      :data="rolelist"
				      style="width: 100%">
				      <el-table-column
					    align="center"
				        prop="createTime"
				        label="创建时间"
				        width="180">
				      </el-table-column>
				      <el-table-column
					    align="center"
				        prop="id"
				        label="ID"
				        width="180">
				      </el-table-column>
					  <el-table-column
					    align="center"
					    prop="roleName"
					    label="角色名称">
					  </el-table-column>
				      <el-table-column
					    align="center"
				        prop="remarks"
				        label="备注">
				      </el-table-column>
					  <el-table-column
					    align="center"
					    label="操作">
						<template slot-scope="scope">
						    <el-button  size="mini" @click="handleEdit(scope.row)" style="margin-right: 10px;">编辑</el-button>
							<el-popconfirm title="确定删除该角色吗？" @confirm="handleDelete(scope.row.id)">
								<el-button  slot="reference" size="mini"  type="danger" style="margin-right: 10px;">删除</el-button>
							</el-popconfirm>
							<el-button  size="mini" @click="handleUser(scope.row)" style="margin-right: 10px;">分配用户</el-button>
						</template>
					  </el-table-column>
				    </el-table>
					<div style="display: flex;justify-content: center;margin:20px">
						<el-pagination background layout="prev, pager, next" :total="total" @current-change="onchangepage"></el-pagination>
					</div>
				</template>
			</el-tab-pane>
		    <el-tab-pane label="分配角色" name="second" v-if="roletype">
		    	<vs-row class="mb-4">
					<vs-col vs-type="flex">
						<el-form :inline="true" :model="search" class="demo-form-inline">
						  <el-form-item label="姓名">
						    <el-input v-model="search.name" placeholder="请输入姓名"></el-input>
						  </el-form-item>
						  <el-form-item label="手机号">
						    <el-input v-model="search.phone" placeholder="请输入手机号"></el-input>
						  </el-form-item>
						  <el-form-item>
						    <el-button type="primary" @click="getuser()">查询</el-button>
						  </el-form-item>
						</el-form>
					</vs-col>
		    		<vs-col vs-type="flex">
						<p style="display: flex;align-items: center;margin-right: 30px;">当前角色：<el-tag>{{roletype.roleName}}</el-tag></p>
		    			<el-button type="primary" plain icon="el-icon-plus" size="mini" @click="()=>{this.innerVisible=true}">添加用户</el-button>
						<el-button type="danger" plain icon="el-icon-delete" size="mini" @click="scopelist">批量取消授权</el-button>
		    		</vs-col>
		    	</vs-row>
		    	<template>
		    	    <el-table
		    		  :header-cell-style="{background:'#F3F4F7',color:'#000000'}"
					  ref="multipleTable"
		    		  align="center"
		    	      :data="userlist"
					  @selection-change="handleSelectionChange"
		    	      style="width: 100%">
					  <el-table-column
					    type="selection"
					    width="55">
					  </el-table-column>
		    	      <el-table-column
		    		    align="center"
		    	        prop="createTime"
		    	        label="创建时间"
		    	        width="180">
		    	      </el-table-column>
		    	      <el-table-column
		    		    align="center"
		    	        prop="id"
		    	        label="ID"
		    	        width="180">
		    	      </el-table-column>
		    	      <el-table-column
		    		    align="center"
		    	        prop="name"
		    	        label="姓名">
		    	      </el-table-column>
					  <el-table-column
					    align="center"
					    prop="phone"
					    label="手机号">
					  </el-table-column>
					  <el-table-column
					    align="center"
					    prop="email"
					    label="邮箱">
					  </el-table-column>
		    		  <el-table-column
		    		    align="center"
		    		    label="操作">
		    			<template slot-scope="scope">
		    			    <el-button  icon="el-icon-circle-close" type="text" @click="cancelscop(scope.row.userRoleId)">取消授权</el-button>
		    			</template>
		    		  </el-table-column>
		    	    </el-table>
					<div style="display: flex;justify-content: center;margin:20px">
						<el-pagination background layout="prev, pager, next" :total="totaluser" @current-change="onchangepageuser"></el-pagination>
					</div>
		    	</template>
		    </el-tab-pane>
		  </el-tabs>
		<!-- 分配用户 -->
		<Auditor :innerVisible="innerVisible" v-if="innerVisible"  @closediaglo="closediaglo()" @submitmember="submitmember"></Auditor>
		<!-- 弹窗 -->
		<div class="demo-alignment">
		    <el-dialog title="角色信息" :visible.sync="diaglo" width="50%" :close-on-click-modal="false" center>
		  	<el-form  label-width="120px" >
				<el-form-item label="角色名:">
					<el-input v-model="role.roleName" placeholder="请输入角色名称" class="ml-4" style="width: 80%;"></el-input>
				</el-form-item>
				<el-form-item label="状态:" prop="resource">
				    <el-radio-group v-model="role.status" style="padding: 0 15px;">
				      <el-radio label="0">正常</el-radio>
				      <!-- <el-radio label="停用" :value="1"></el-radio> -->
				    </el-radio-group>
				</el-form-item>
				<el-form-item label="部门权限:">
					<el-cascader style="width:360px" ref="dept" v-model="deptid" collapse-tags :options="options" @change="changeIndustrial" placeholder="请选择部门" :props="{ multiple:true,checkStrictly: false,value:'id',label:'name'}"  class="ml-4"></el-cascader>
				</el-form-item>
				<el-form-item label="模块权限:">
					<div style="margin: 0 15px;">
					<el-checkbox label="展开/折叠" name="type" v-model="controlemoudles.fold"></el-checkbox>
					<el-checkbox label="全选/全不选" name="type" v-model="controlemoudles.select"></el-checkbox>
					<el-checkbox label="父子联动" name="type" disabled v-model="controlemoudles.relation"></el-checkbox>
					</div>
					<div style="border: 1px solid #DCDFE6;margin: 0 15px;width:80%">
					<el-tree
					  :data="moudles"
					  show-checkbox
					  node-key="id"
					  ref="tree"
					  :default-expand-all="controlemoudles.fold"
					  highlight-current
					  check-strictly
					  :props="defaultProps"
					  @check="clickDeal">
					</el-tree>
					</div>
		  	    </el-form-item>
				<el-form-item label="备注:">
				    <el-input type="textarea" style="width: 80%;margin: 0 15px;" v-model="role.remarks"></el-input>
				</el-form-item>
		  	</el-form>	
			<span slot="footer" class="dialog-footer">
					<el-button @click="diaglo = false">取 消</el-button>
					<el-button type="primary" @click="save" v-if="role.id==''">保 存</el-button>
					<el-button type="primary" @click="edit" v-else >确 定</el-button>
			</span>
		    </el-dialog>
		</div>
	</div>
</template>

<script>
	import Auditor from '@/components/Auditor'
	export default {
	    data() {
	        return {
				activeName:"first",
				role:{id:'',roleName:'',deptIds:'',status:"0",menuIds:[],remarks:''},
				diaglo:false,
				defaultProps: {
				    children: 'children',
				    label: 'menuName'
				},
				controlemoudles:{fold:false,select:false,relation:true}, //模块控制
				moudles:[],   //模块
				rolelist: [],
				itemsPerPage:1,
				total:0,
				innerVisible:false,
				roletype:"",  //角色类型
				userlist:[],
				search:{name:'',phone:''},
				itemsPerPageuser:1,
				totaluser:0,
				userscope:[],
				options:[],     //部门列表
				deptid:[],
			}
	    },
		mounted() {
			this.getoptions();
			this.getrole();
		},
		components: {
		  Auditor,
		},
		watch:{
			'controlemoudles.fold'(newval,oldval){
				console.log("从",oldval,"=>",newval);
				this.DynamicScaling();
			},
			'controlemoudles.select'(newval,oldval){
				if(newval){
					this.$refs.tree.setCheckedNodes(this.moudles)
				}else{
					this.$refs.tree.setCheckedKeys([])
				}
			},
		},
		methods:{
			changeIndustrial(val){   //级联数据处理
				console.log(val);
				let checklist=this.$refs['dept'].getCheckedNodes();
				let ids = [];
				  checklist.forEach((item) => {
					  if(item.checked){
						  ids.push(item.value);
					  }
				    //ids.push(item[item.length - 1]);
				  })
				this.role.deptIds = ids.join(',');
				console.log("处理之后的数据",this.role.deptIds);
				
			},
			// 级联回显
			industrialChinaShow (codes) {
			      let echoTreeArr = [];
			      let eachAry = codes.split(',')
			      let itemAry = [];//分类树组件，每一项的code数组
			      // 递归分类数据
			      let recursionCategory = (data) => {
			        let len = data.length;
			        for (let i = 0; i < len; i++) {//循环data参数，匹配回显的code
			          itemAry.push(data[i].id);//构建分类树数组项,入栈
			          for (let j = 0; j < eachAry.length; j++) {//遍历子节点分类code，拼凑成数组项code，并终止循环
			            if (eachAry[j] == data[i].id) {//匹配到子节点code
			              echoTreeArr.push(JSON.parse(JSON.stringify(itemAry)));//push进树分类数据
			              eachAry.splice(j, 1);//删除以匹配到的code
			              break;
			            }
			          }
			          if (eachAry.length <= 0) {//所有回显code匹配完成后，跳出循环
			            break;
			          } else if (data[i].children && data[i].children.length > 0) {// 如果存在子分类，递归继续
			            recursionCategory(data[i].children);
			          }
			          itemAry.pop();//出栈
			        }
			      }
			      recursionCategory(this.options);//调用递归
			      this.deptid = echoTreeArr;
			},
			getoptions(){	//获取部门列表
				const that = this;
				this.$api.getmember({}).then(function (response) {
						console.log("组织架构：",response);
						if(response.code==0){
							that.options=that.removeEmptyChildren(response.data);
						}else{
							that.$vs.notify({
								title:"提示",
								color:'warning',
								text:response.message,
								position:'top-center'
							});
						}
				})
			},
			removeEmptyChildren (node) {   //杀生
				var that=this;
				node.forEach(item => {
				if ('children' in item && item.children.length === 0) {
					delete item.children
				} else if ('children' in item && item.children.length) {
					that.removeEmptyChildren(item.children)
				}
				})
				return node;
			},
			onchangepage(val){
				this.itemsPerPage=val;
				this.getrole();
			},
			onchangepageuser(val){
				this.itemsPerPageuser=val;
				this.getuser();
			},
			getuser(){
				const that = this;
				this.$api.roleuserpage({pageNum:that.itemsPerPageuser,pageSize:10,roleId:that.roletype.id,name:that.search.name,phone:that.search.phone}).then(function (response) {
					console.log("用户数据：",response);
					if(response.code==0){
						 that.userlist=response.data.data;
						 that.totaluser=response.data.total;
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				  }) 
			},
			getrole(){
				const that = this;
				this.$api.rolepage({pageNum:that.itemsPerPage,pageSize:10}).then(function (response) {
					console.log("列表数据：",response);
					if(response.code==0){
						 that.rolelist=response.data.data;
						 that.total=response.data.total;
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				  }) 
			},
			handleClick(){
				console.log("切换");
			},
			addrole(){  //新增角色
				console.log("新增角色");
				const that = this;
				this.role={id:'',roleName:'',status:"0",menuIds:[],remarks:'',deptIds:''};
				this.deptid=[];
				this.$api.getmoudle({}).then(function (response) {
					console.log("菜单：",response);
					if(response.code==0){
						 that.moudles=response.data;
						 that.$refs.tree.setCheckedKeys([]);
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				  })
				this.diaglo=true;
			},
			save(){   //保存新增角色
				const that = this;
				this.role.menuIds=this.$refs.tree.getCheckedKeys().toString();
				this.$api.rolesave(that.role).then(function (response) {
					if(response.code==0){
						that.$vs.notify({
							  title:"提示",
							  color:'success',
							  text:response.message,
							  position:'top-center'
						});
						that.getrole();
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				  })
				this.diaglo=false;
			},
			edit(){
				const that = this;
				this.role.menuIds=this.$refs.tree.getCheckedKeys().toString();
				this.$api.roleedit(that.role).then(function (response) {
					if(response.code==0){
						that.$vs.notify({
							  title:"提示",
							  color:'success',
							  text:response.message,
							  position:'top-center'
						});
						that.getrole();
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				  })
				this.diaglo=false;
			},
			handleDelete(id){  //删除角色
				const that = this;
				this.$api.roledel({id:id}).then(function (response) {
					if(response.code==0){
						that.$vs.notify({
							  title:"提示",
							  color:'success',
							  text:response.message,
							  position:'top-center'
						});
						that.getrole();
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				  })
			},
			handleEdit(item){	//编辑角色
				const that = this;
				this.$api.getmoudle({}).then(function (response) {
					console.log("菜单：",response);
					if(response.code==0){
						 that.moudles=response.data;
						 that.role.id=item.id;
						 that.role.menuIds=item.menuIds;
						 if(item.deptIds){
							 that.role.deptIds=item.deptIds.join(",");
							 that.industrialChinaShow(that.role.deptIds);
						 }else{
							 that.role.deptIds=item.deptIds;
							 that.deptid=[];
						 }
						 
						 that.role.roleName=item.roleName;
						 that.role.remarks=item.remarks;
						 that.$refs.tree.setCheckedKeys(item.menuIds);
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				  })
				that.diaglo=true;
			},
			handleUser(item){ //分配用户
				this.roletype=item;
				this.getuser();
				this.activeName="second";
			},
			submitmember(val){  //选中的用户
				console.log("当前选择的用户：",val);
				const that = this;
				var arr=[];
				val.forEach(item=>{
					arr.push(item.id);
				})
				this.$api.roleuserassign({userId:arr.toString(),roleId:that.roletype.id}).then(function (response) {
					that.getuser();
					if(response.code==0){
						 that.$vs.notify({
						 	  title:"提示",
						 	  color:'success',
						 	  text:response.message,
						 	  position:'top-center'
						 });
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				  })
			},
			scopelist(){  //批量取消
				var that=this;
				if(this.userscope.length==0){
					that.$vs.notify({
						  title:"提示",
						  color:'warning',
						  text:"请选择项",
						  position:'top-center'
					});
					return false;
				}
				var item=[];
				that.userscope.forEach(it=>{
					item.push(it.userRoleId);
				})
				that.cancelscop(item.toString());
			},
			cancelscop(item){	//取消授权
				var that=this;
				this.$api.roleusercancel({userRoleId :item}).then(function (response) {
					that.getuser();
					if(response.code==0){
						 that.$vs.notify({
						 	  title:"提示",
						 	  color:'success',
						 	  text:response.message,
						 	  position:'top-center'
						 });
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				  })
			},
			closediaglo(){
				this.innerVisible=false;
			},
			DynamicScaling(){
			      for(let j=0; j<this.$refs.tree.store._getAllNodes().length; j++){
			        this.$refs.tree.store._getAllNodes()[j].expanded= this.controlemoudles.fold;
			      }
			},
			clickDeal (currentObj, treeStatus) {
				console.log("节点操作",currentObj)
			  // 用于：父子节点严格互不关联时，父节点勾选变化时通知子节点同步变化，实现单向关联。
			  let selected = treeStatus.checkedKeys.indexOf(currentObj.id) // -1未选中
			  // 选中
			  if (selected !== -1) {
			    // 子节点只要被选中父节点就被选中
			    this.selectedParent(currentObj)
			    // 统一处理子节点为相同的勾选状态
			    this.uniteChildSame(currentObj, true)
			  } else {
			    // 未选中 处理子节点全部未选中
			    if (currentObj.children.length !== 0) {
			      this.uniteChildSame(currentObj, false)
			    }
			  }
			},
			uniteChildSame (treeList, isSelected) {
			  this.$refs.tree.setChecked(treeList.id, isSelected)
			  if (treeList.children) {
			    for (let i = 0; i < treeList.children.length; i++) {
			      this.uniteChildSame(treeList.children[i], isSelected)
			    }
			  }
			},
			// 统一处理父节点为选中
			selectedParent (currentObj) {
			  let currentNode = this.$refs.tree.getNode(currentObj)
			  if (currentNode.parent.key !== undefined) {
			    this.$refs.tree.setChecked(currentNode.parent, true)
			    this.selectedParent(currentNode.parent)
			  }
			},
			
			handleSelectionChange(val) {
			    console.log("选中的用户",val);
				this.userscope=val;
			}
		}
	}
</script>

<style>
	.role{
		background: #FFFFFF;
		padding: 30px;
		min-height: 70vh;
	}
</style>
